import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Navbar, Offcanvas } from 'react-bootstrap';
import Lobby from './Lobby';
import Chat from './Chat';
import FriendList from './FriendList/FriendList';
import logo from '../img/evosquare_logo_titled.png';
import useInterval from './Functions/UseInterval';
import onlinePing from './Functions/OnlinePing';
import goOffline from './Functions/GoOffline';
import OnlineUser from './OnlineUser';

function MainMenu({ onLogout }) {
    const [showLobbies, setShowLobbies] = useState(false);
    const [isRunning, setIsRunning] = useState(() => Boolean(localStorage.getItem('JWToken')));
    const [pingStatus, setPingStatus] = useState(null);
    
    const [showSidebar, setShowSidebar] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setIsRunning(Boolean(localStorage.getItem('JWToken')));
    }, []);

    const handleLogout = async () => {
        setIsRunning(false);
        const token = localStorage.getItem('JWToken');
        try { await goOffline(token); } catch { }
        localStorage.removeItem('JWToken');
        sessionStorage.removeItem('currentLobby');
        sessionStorage.removeItem('currentLobbyId');
        onLogout?.();
        navigate('/login');
    };

    useInterval(async () => {
        const token = localStorage.getItem('JWToken');
        if (!token) { setIsRunning(false); return; }
        try {
            const status = await onlinePing(token);
            setPingStatus(status);
        } catch (err) { console.log("Server not reachable"); }
    }, isRunning ? 60000 : null);

    // --- REUSABLE SIDEBAR CONTENT ---
    const SidebarContent = () => (
        <Card className="shadow bg-dark-transparent text-white h-100 border-0 d-flex flex-column">
            {/* 1. Header: Logo */}
            <Card.Header className="text-center border-bottom border-secondary flex-shrink-0">
                <img
                    style={{ height: "80px", width: "auto" }}
                    src={logo}
                    alt="Chess Logo"
                />
            </Card.Header>

            {/* 2. Body: Scrollable area for lists */}
            <Card.Body className="overflow-auto flex-grow-1 p-2 custom-scrollbar">
                <div className="mb-3">
                    <FriendList />
                </div>
                <hr className="border-secondary my-3"/>
                <div>
                    
                    <OnlineUser />
                </div>
            </Card.Body>

            {/* 3. Footer: Buttons fixed at bottom */}
            <Card.Footer className="d-flex gap-2 flex-shrink-0 border-top border-secondary bg-dark-transparent p-3">
                <Button
                    variant="primary"
                    className="flex-grow-1 menu-button txt-dark-green bg-light-green fw-bold"
                    size="lg"
                    onClick={() => navigate('/gamehub')}
                >
                    GAME
                </Button>
                <Button
                    onClick={handleLogout}
                    variant="danger"
                    className="menu-button"
                    size="lg"
                    style={{ aspectRatio: '1 / 1' }}
                >
                    <i className="bi bi-box-arrow-left"></i>
                </Button>
            </Card.Footer>
        </Card>
    );

    // --- MAIN RENDER ---
    return (
        <Container fluid className="bg-chess vh-100 d-flex flex-column p-0 overflow-hidden">
            
            {/* 1. MOBILE NAVBAR */}
            {isMobile && (
                <Navbar bg="dark" variant="dark" className="border-bottom border-secondary px-3 flex-shrink-0 justify-content-between" style={{ height: '60px' }}>
                    <Button variant="outline-light" onClick={() => setShowSidebar(true)}>
                        <i className="bi bi-list"></i> Menu
                    </Button>
                    <Navbar.Brand className="mx-auto fw-bold text-light-green">EvoSquare</Navbar.Brand>
                    <div style={{ width: '40px' }}></div>
                </Navbar>
            )}

            {/* 2. MAIN LAYOUT CONTAINER */}
            <Container fluid={isMobile} className={`h-100 ${isMobile ? 'p-0' : 'py-5 container'}`}>
                <Row className="h-100 g-3 justify-content-center">
                    
                    {/* DESKTOP SIDEBAR */}
                    {!isMobile && (
                        <Col md={4} style={{ height: "60rem" }}>
                            <SidebarContent />
                        </Col>
                    )}

                 
                    <Col xs={12} md={8} style={{ height: isMobile ? "calc(100vh - 60px)" : "60rem" }}>
                        <Card className="shadow bg-dark-transparent text-white h-100 border-0">
                            <Card.Body className="p-0 h-100 position-relative">
                                <div className="position-absolute w-100 h-100">
                                    <Chat />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* 3. MOBILE OFFCANVAS (Hamburger) */}
            <Offcanvas 
                show={showSidebar} 
                onHide={() => setShowSidebar(false)} 
                placement="start" 
                className="bg-dark text-white w-85" 
                style={{ maxWidth: '350px' }}
                enforceFocus={false}
                autoFocus={false}
                restoreFocus={false}
            >
                <Offcanvas.Header closeButton closeVariant="white" className="border-bottom border-secondary">
                    <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="p-0 h-100">
                    <SidebarContent />
                </Offcanvas.Body>
            </Offcanvas>

            {/* LOBBY MODAL */}
            <Lobby
                show={showLobbies}
                onHide={() => setShowLobbies(false)}
                onCreate={(l) => { sessionStorage.setItem('currentLobby', JSON.stringify(l)); navigate('/gamehub'); }} 
                onJoin={(l) => { sessionStorage.setItem('currentLobby', JSON.stringify(l)); navigate('/gamehub'); }} 
            />
        </Container>
    );
}

export default MainMenu;